import React from "react";
import { string } from "prop-types";

const FacebookIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="28"
    width="15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 .202v4.442h-2.726c-.995 0-1.666.202-2.014.606-.347.404-.52 1.01-.52 1.817v3.18h5.086l-.677 4.981H9.74V28H4.428V15.228H0v-4.98h4.427V6.579c0-2.086.602-3.702 1.806-4.846C7.436.578 9.039 0 11.042 0c1.701 0 3.02.067 3.958.202Z"
      fill="#1876DB"
    />
  </svg>
);

FacebookIcon.propTypes = {
  className: string
};

FacebookIcon.defaultProps = {
  className: ""
};

export default FacebookIcon;
